/* eslint-disable no-debugger */
import { call, all, spawn, put, takeLatest } from 'redux-saga/effects';

import { showToast } from '../Toast/actions';
import { SET_ENV } from './constants';
import { setEnvSuccess } from './actions';

export function* setEnvSaga({ payload }) {
  try {
    // Update Redux state
    yield put(setEnvSuccess(payload));
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* watchSetEnvSaga() {
  yield takeLatest(SET_ENV, setEnvSaga);
}

export default function* mainLayoutSaga() {
  const sagas = [watchSetEnvSaga];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
